<script setup>
import {useModalsStore} from '@/stores/modals'

// Pinia Stores
const modalsStore = useModalsStore()

// --- Methods ---

const openFindModal = () => {
    modalsStore.show({
        componentName: 'ThemesFindModal',
    })
}
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="openFindModal">
        <i class="me-2 bi-search"/>
        Find
    </button>
</template>